import * as React from 'react'

export default () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#a)' stroke='currentColor' strokeLinecap='round'>
      <path d='M2 4h20M2 12h20M2 20h20' />
    </g>
    <defs>
      <clipPath id='a'>
        <path fill='currentColor' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
